import {AbstractStep} from "./AbstractStep";
import {ICategory, ISelection, IStepParams} from "./index";
import {Categories, Selections, SelectionTypes} from "./_def";
import {getObjectDefinition, getObjectType} from "../../../util/misc";
import {RuleMutable} from "./RuleMutable";
import step_1Html from './step-1.html?raw';

export let template = step_1Html;

export class viewModel extends AbstractStep {

    private readonly Categories = Categories;
    private readonly SelectionTypes = SelectionTypes;
    private readonly Selections = Selections;
    protected ruleMutable: RuleMutable = this.settings.ruleMutableSelection;

    constructor(params: IStepParams) {
        super(params);

        this.kosub.subscribe(this.settings.category, c => {
            if (!c) {
                return
            }
            const def = getObjectDefinition(c.objectTypeId);
            if (!def) {
                return;
            }
            this.settings.objectType({
                def: def,
                id: c.objectTypeId,
                type: getObjectType(c.objectTypeId),
            })
        });

        this.kosub.subscribe([
            this.settings.category,
            this.settings.selectionType,
            this.settings.selection,
            this.isValidRuleSelection,
        ] as KnockoutSubscribable<unknown>[], () => this.doValidation());

        this.kosub.subscribe([
            this.settings.category,
            this.settings.selectionType,
        ] as KnockoutSubscribable<unknown>[], () => {
            const selection = this.settings.selection()
            if (!selection) {
                return;
            }
            if (!this.isSelectionAvailable(selection)) {
                this.settings.selection(null);
            }
        });
    }

    protected validate(): boolean {
        const a = !!this.settings.category();
        this.et.update(!a, this.settings.category, 'invalid s|s:((category|ac))');
        const b = !!this.settings.selectionType();
        this.et.update(!b, this.settings.selectionType, 'invalid s|s:((type|ac))');
        const c = !!this.settings.selection();
        this.et.update(!c, this.settings.selection, 'invalid s|s:((selection|ac))');
        const z = this.settings.ruleMutableSelection.isValid();
        return a && b && c && z;
    }

    private isSelectionAvailable(selection: ISelection): boolean {
        return !!this.getAvailableSelections().find(s => s === selection);
    }

    private getAvailableSelections(): ISelection[] {
        const categoryValue = this.settings.category()?.value
        const selectionTypeValue = this.settings.selectionType()?.value
        if (!categoryValue || !selectionTypeValue) {
            return []
        }
        return this.Selections
            .filter(s => s.category.indexOf(categoryValue) != -1)
            .filter(s => s.type == selectionTypeValue);
    }

    private getAvailableCategories(): ICategory[] {
        return this.Categories.filter(c => this.isCategoryEnabled(c));
    }

    private isCategoryEnabled(category: ICategory): boolean {
        if (this.settings.mutableRuleset.canChangeObjectType()) {
            return true;
        }
        return category.objectTypeId == this.settings.initialObjectTypeId;
    }

    private getSelectionName(name: string): string {
        return name.replace('{{CATEGORY_NAME}}', 'a ' + this.settings.category()?.name + '|ac');
    }

}
